export default "__VITE_ASSET__DmNC$pq3__"